import { render, staticRenderFns } from "./HorizontalStackedBarChart.vue?vue&type=template&id=dd9899f0&"
import script from "./HorizontalStackedBarChart.vue?vue&type=script&lang=js&"
export * from "./HorizontalStackedBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports